import { EVENT_TYPES } from "./index.js";

const dataTrackDefault = {
  event_type: null,
  data: null,
  event_id: null,
}

export const stateChangeHandler = ({
  event = dataTrackDefault,
  handleStateChange,
}) => {
  const { event_type, data, event_id } = event ?? {}
  if (event_type === EVENT_TYPES.STATE_CHNAGE) {
    handleStateChange(data, event_id);
  }
}
